<template>
  <div class="publicMain">
    <el-row>
      <el-table
          v-loading="tabLoading"
        :element-loading-text="$t('elTable.loadingText')"
        element-loading-spinner="el-icon-loading"
          :cell-style="$store.state.cellStyle"
          :data="tableData"
          :header-cell-style="$store.state.headerCellStyle"
          border
          style="width: 100%; font-size: 12px;"
      >
        <el-table-column :label="$t('rcsw.sqdh')" align="center" header-align="center" prop="sqid"
                         width="200px"></el-table-column>
        <el-table-column :label="$t('rcsw.fwmc')" align="center" header-align="center" prop="fwmc"></el-table-column>
        <el-table-column :label="$t('rcsw.synopsis')" align="center" header-align="center" prop="fwjj"></el-table-column>
        <el-table-column :label="$t('rcsw.type')" align="center" header-align="center" prop="lxmc" width="100px"></el-table-column>
        <el-table-column :label="$t('rcsw.tdsj')" align="center" header-align="center" prop="sqsj"
                         width="120px">
          <template slot-scope="scope">
            {{ scope.row.sqsj.slice(0, 4) }}-{{ scope.row.sqsj.slice(4, 6) }}-{{ scope.row.sqsj.slice(6, 8) }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('rcsw.state')" align="center" header-align="center" prop="cg" width="100px">
          <template slot-scope="scope">
            <!--            {{ scope.row.zt == '0' ? '待审批' : scope.row.zt == '1' ? '通过' : scope.row.zt == '2' ? '驳回' : '草稿' }}-->
            {{ scope.row.cg == '1' ? $t('common.draft') : scope.row.zt == '0' ? $t('rcsw.dsp') : scope.row.zt == '1' ? $t('rcsw.adopt') : $t('rcsw.reject') }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('rcsw.tdr')" align="center" header-align="center" prop="sqr" width="100px"></el-table-column>
        <el-table-column :label="$t('rcsw.spr')" align="center" header-align="center" prop="spr" width="100px"></el-table-column>
        <el-table-column :label="$t('common.operation')" align="center" header-align="center" width="100px">
          <template slot-scope="scope">
            <el-button v-if="scope.row.cg =='1'"
                       type="text"
                       @click="openDialog('edit',  scope.row)">
              {{ $t('common.editBtn') }}
            </el-button>
            <el-button v-if="scope.row.cg =='1'"
                       type="text"
                       @click="openDialog('del', scope.row)">
              {{ $t('common.deleteBtn') }}
            </el-button>
            <el-button
                v-if="scope.row.cg !== '1'"
                type="text"
                @click="openDialog('draft', scope.row)"
            >{{ $t('rcsw.details') }}
            </el-button>
            <el-button
                v-if="scope.row.zt == '1'"
                type="text"
                @click="openDialog('download', scope.row)">{{ $t('rcsw.download') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <!--        分页组件-->
      <Pagination
          :currentPage="currentPage"
          :limit="limit"
          :pageSizes="$store.state.pageSizes"
          :small="true"
          :total="total"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
      />
    </el-row>
    <!-- 我的单子模态框 -->
    <el-dialog
        v-dialogDrag
        :close-on-click-modal="false"
        :close-on-press-escape="true"
        :title="dialogTitle"
        :visible.sync="dialogFormVisible"
        @close="handleClose"
    >
      <label slot="title">
        <i :class="dialogTitleIcon" style="font-size: 16px; font-weight: bold;">
                    <span style="margin-right: 5px;">
                        {{ this.dialogTitle }}
                    </span>
        </i>
      </label>

      <el-card style="padding: 0 5% 0 5%">
        <el-form
            ref="ruleForm"
            :model="ruleForm"
            :rules="rules"
            :validate-on-rule-change="false"
            size="small"
        >

          <el-form-item label-width="20px">
            <!--图片显示-->
            <div v-if="result.zt=='1'&&picShow1" class="demo-image">
              <div class="block" style="float:right;">
                <el-image
                    :fit="fit"
                    :src="require('@/assets/img/tg.png')"
                    style="width: 100px; height: 100px"></el-image>
              </div>
            </div>

            <div v-if="result.zt=='2'&&picShow1" class="demo-image">
              <div class="block" style="float:right;">
                <el-image
                    :fit="fit"
                    :src="require('@/assets/img/bh.png')"
                    style="width: 100px; height: 100px"></el-image>
              </div>
            </div>

            <div style="font-size: 25px;"> {{$t('rcsw.downloadsm')}}</div>
            <div>{{$t('rcsw.cjr')}}：{{ result.xm + result.xgh }}</div>
            <div><span style="margin-right: 20px">{{$t('rcsw.cjrq')}}：{{ result.cjsj.slice(0, 4) }}-{{
                result.cjsj.slice(4, 6)
              }}-{{ result.cjsj.slice(6, 8) }}</span>{{$t('rcsw.type')}}：{{ result.lxmc }}
            </div>
            <h3>{{$t('rcsw.synopsis')}}：{{ result.fwjj }}</h3>
          </el-form-item>

          <el-card>
            <label style="font-weight: bold;color: #606266">{{$t('rcsw.tdr')}}</label>
            <el-form-item style="margin-top: 15px">
              <span style="font-size: 13px">{{$t('rcsw.xm')}}：{{ result.xm }}</span>
              <span style="font-size: 13px;margin-left: 20px">{{$t('rcsw.xgh')}}：{{ result.xgh }}</span>
              <span style="font-size: 13px;margin-left: 20px">{{$t('rcsw.department')}}：{{ result.bm }}</span>
              <span style="font-size: 13px;margin-left: 20px">{{$t('rcsw.lxdh')}}：{{ result.lxfs }}</span>
              <span style="font-size: 13px;margin-left: 20px">{{$t('rcsw.dzyx')}}：{{ result.dzyx }}</span>
            </el-form-item>
          </el-card>

          <el-card
              v-if="jsonData.fields"
              style="margin-top: 20px"
          >
            <Parser ref="parser" :form-conf="this.jsonData" @submit="submitFromData"></Parser>
          </el-card>

          <el-form
              ref="form"
              :model="form"
              :rules="rules"
              class="demo-dynamic"
              size="mini"
          >
            <el-card v-for="(item,index) in form.itemList"
                     :key="item.key"
                     style="margin-top: 20px;font-weight: bold"
            >
              <el-form-item
                  :label="item.zdbt ? item.sfbt==='1' ? item.zdbt+'(必填)':item.zdbt :item.zdbt "
                  :prop="'itemList.' + index + '.zd'"
                  :rules="{required:item.sfbt==='1' ? true:false , message: $t('rcsw.qsrbtx'), trigger: 'blur'}"
              >

                <el-input
                    v-model.trim="item.zd"
                    :disabled="disabledFlg"
                    size="small"
                ></el-input>

              </el-form-item>


            </el-card>
            <el-card v-show="result.zt=='2'" style="margin-top: 20px;font-weight: bold">
              <el-form-item
                  :label="$t('rcsw.Reasonrejection')"
              >
                <el-input
                    v-model="this.result.bhyy"
                    :disabled="disabledFlg"
                    size="small"
                ></el-input>
              </el-form-item>
            </el-card>


          </el-form>
        </el-form>
      </el-card>
      <div slot="footer" class="dialog-footer">
        <el-button v-if="show" icon="el-icon-check" size="small" type="primary" @click="submitForm('form','0')">
          {{$t('rcsw.qrtj')}}
        </el-button>
        <el-button v-if="show" icon="el-icon-document" size="small" type="warning" @click="submitForm('form','1')">
          {{$t('rcsw.bccg')}}
        </el-button>
      </div>
    </el-dialog>


    <!--下载附件模态框-->
    <el-dialog v-dialogDrag
               :close-on-click-modal="false"
               :close-on-press-escape="true"
               :visible.sync="dialogFormVisible2"
               :title="$t('rcsw.fwfj')"
               width="30%"
    >
      <el-table :cell-style="$store.state.cellStyle"
                :data="fwfjList"
                :header-cell-style="$store.state.headerCellStyle"
                border
      >
        <el-table-column align="center"
                         header-align="center"
                         :label="$t('rcsw.fjmc')"
                         prop="fjmc">
        </el-table-column>

        <el-table-column align="center" header-align="center" :label="$t('common.operation')" property="name"
                         width="200">
          <template slot-scope="scope">
            <el-button
                type="text"
                @click="filedownload(scope.row)"
            >
              <li class="el-icon-download"></li>
            </el-button>
          </template>


        </el-table-column>
      </el-table>
    </el-dialog>

  </div>
</template>
<script>
import {downLoadFile, openDialogDownload} from '@/api/common'

export default {
  name: "serviceView",
  computed: { // 计算属性
    rules() {
      // 模态框数据校验规则
      return {
        zd: [
          {required: true, message: this.$t('rcsw.qsrbtx'), trigger: "blur"},
        ]
      };
    },
    tabHeight() {
      return this.screenHeight - 385;
    },
  },
  data() {
    return {
      jsonData: {},
      reason: false,
      picShow1: false, // 驳回图片是否展示
      fit: 'cover',
      form: {
        itemList: []
      },
      result: {
        cjrzjh: "",
        cjsj: "",
        lxmc: "",
        fwjj: "",
        xm: "",
        xgh: "",
        bm: "",
        lxfs: "",
        dzyx: "",
        xh: "",
        zdbt: "",
        zd: "",
        cg: "",
        sqr: "", // 申请人
        bhyy: "", // 驳回原因
        zt: ""
      },
      fwfjList: [],
      queryForm: {
        yhmc: "",
        yhbh: "",
      },
      tableData: [],
      dialogFormVisible: false,
      dialogFormVisible2: false,
      show: false,
      dialogTitle: "", // 模态框标题
      dialogTitleIcon: "", // 模态框标题图标
      ruleForm: {
        xh: "",
        zd: "",
        sqid: "",
        fwid: "",
        cg:"",
        form: [],
      },
      currentPage: 1, // 页码
      limit: this.$store.state.dataDisplayNum, // 分页显示条数
      total: 0, // 列表数据量
      pageSizes: this.$store.state.pageSizes, // 分页显示可选择条数
      tabLoading: true, // 表格请求数据loading层
      disabledFlg: false, // 输入框是否可编辑
      showFlg: false, // 元素是否显示
      optionsRole: [], // 用户角色
      saveFlg: "", // 保存操作区分
      optionsUserState: [], // 用户状态
      tmpPwd: "",
      screenHeight: "0",

    };
  },
  methods: {
    // validatePassWord(rule, value, callback) {
    //   if (this.ruleForm.zd == '1'){
    //     callback();
    //   }else {
    //     if (value == "") {
    //       callback(new Error("必填选项不能为空"));
    //     } else {
    //       callback();
    //     }
    //   }
    // },
    handleClose(done) {
      this.$refs["ruleForm"].resetFields();
      this.$refs["form"].resetFields();
      this.jsonData = {};
    },
    /** 打开模态框 */
    openDialog(flg, row) {
      if (flg == "add") {
        this.dialogFormVisible = true;
        this.$nextTick(() => {
          this.dialogTitle = this.$t("yhgl.addDiaTitle");
          this.dialogTitleIcon = "el-icon-document-add";
          this.disabledFlg = false;
          this.showFlg = true;
        });
      } else if (flg == "edit") {
        this.dialogFormVisible = true;
        this.dialogTitle = this.$t("rcsw.editDiaTitle");
        this.dialogTitleIcon = "el-icon-edit-outline";
        this.ruleForm.sqid = row.sqid;
        this.queryUserInfo(row.sqid);
        this.searchTdrInfo(row.sqid);
        this.getBdzdb(row.cg,row.sqid);
        this.getJsonByFwid(row.fwid);
        // this.getBhyy(row.sqid);
        this.disabledFlg = false;
        this.showFlg = true;
        this.show = true; // 提交按钮是否展示
        this.picShow1 = false;//点击编辑按钮时是草稿状态  让通过和驳回图片不展示
        this.reason = false;
      } else if (flg == "del") {
        this.delInfo(row.sqid);
      } else if (flg == "draft") {
        // this.$refs['push'].remove();
        this.dialogFormVisible = true;
        this.show = false; // 提交按钮是否展示
        this.dialogTitle = '表单详情';
        this.dialogTitleIcon = "el-icon-edit-outline";
        this.ruleForm.sqid = row.sqid;
        this.queryUserInfo(row.sqid);
        this.searchTdrInfo(row.sqid);
        // this.getBdzdb(row.fwid, row.sqid);
        this.getBdzdb(row.cg, row.sqid);
        this.getJsonByFwid(row.fwid);// 获取json生成的表单字段
        this.getBhyy(row.sqid);
        this.disabledFlg = true;
        this.showFlg = true;
        this.picShow1 = true;
      } else if (flg == "download") {
        this.dialogTitle = this.$t("rcsw.editDiaTitle");
        this.dialogTitleIcon = "el-icon-edit-outline";
        this.dialogFormVisible2 = true;
        this.getFjInfo(row.fwid);
        // this.$nextTick(() => {
        //   this.fwfjList = [];
        // });

      }
      this.saveFlg = flg;
    },
    submitForm(formName,btn) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // alert('submit!');
          // this.addInfo();
          this.ruleForm.cg = btn;
          this.$refs.parser.submitForm();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    getJsonByFwid(fwid) {
      this.$ajax
          .post("/api/getJsonByFwid", this.$qs.stringify({fwid: fwid}))
          .then((res) => {
            if (res.data.code == "200") {
              this.jsonData = JSON.parse(res.data.data)
            } else {
              // this.$message.error(this.$t("resultCodeInfo." + res.data.code));
            }
          })
          .catch((error) => {
            // this.$message.error(this.$t("resultCodeInfo.999"));
          });
    },
    /** 保存模态框数据 */
    // submitForm(formName) {
    //   this.$refs[formName].validate((valid) => {
    //     if (valid) {
    //      if (this.saveFlg === "edit") {
    //         this.addInfo();
    //       }
    //     } else {
    //       console.log("error submit!!");
    //       return false;
    //     }
    //   });
    // },
    // 获取单子的驳回原因
    getBhyy(sqid) {
      let _this = this
      _this.$ajax
          .post("/api/rcsw/getBhyy", _this.$qs.stringify({sqid: sqid}))
          .then((res) => {
            if (res.data.code == "200") {
              if (res.data.data.zt == '2') {
                this.result.bhyy = res.data.data.bhyy
              }
              this.result.zt = res.data.data.zt
            } else {
              // _this.$message.error(_this.$t("resultCodeInfo." + res.data.code));
            }
          })
          .catch((error) => {
            // _this.$message.error(_this.$t("resultCodeInfo.999"));
          });
    },
    // 提交申请单
    // addInfo() {
    //   let _this = this;
    //   for (let i = 0; i < _this.form.itemList.length; i++) {
    //     if (_this.form.itemList[i].sfbt === '1') {
    //       this.ruleForm.zd = this.form.itemList[i].zd;
    //       this.ruleForm.xh = this.form.itemList[i].xh;
    //     }
    //   }
    //   _this.$ajax
    //       .post("/api/rcsw/addInfo", this.ruleForm)
    //       .then((res) => {
    //         _this.dialogFormVisible = false;
    //         if (res.data.code == "200") {
    //           this.searchUser();
    //           _this.$message.success(_this.$t("rcsw.addSuccess"));
    //         } else {
    //           // _this.$message.error(_this.$t("resultCodeInfo." + res.data.code));
    //         }
    //       })
    //       .catch((error) => {
    //         _this.dialogFormVisible = false;
    //         // _this.$message.error(_this.$t("resultCodeInfo.999"));
    //       });
    // },
    submitFromData(formData){
      this.ruleForm.form = formData;
      let _this = this;
        _this.$ajax
            .post("/api/rcsw/addInfo", this.ruleForm)
            .then((res) => {
              _this.dialogFormVisible = false;
              if (res.data.code == "200") {
                this.searchUser();
                _this.$message.success(_this.$t("rcsw.addSuccess"));
              } else {
                // _this.$message.error(_this.$t("resultCodeInfo." + res.data.code));
              }
            })
            .catch((error) => {
              _this.dialogFormVisible = false;
              // _this.$message.error(_this.$t("resultCodeInfo.999"));
            });
    },

    //获取表单字段表数据
    // getBdzdb(fwid, sqid) {
    //   let _this = this
    //   _this.$ajax
    //       .post("/api/rcsw/getBdzdb", _this.$qs.stringify({fwid: fwid, sqid: sqid}))
    //       .then((res) => {
    //         if (res.data.code == "200") {
    //           for (let tmp in res) {
    //             const obj = {
    //               zd: tmp.zd,
    //               xh: tmp.xh,
    //               sfbt: tmp.sfbt
    //             }
    //             this.form.itemList.push(obj)
    //           }
    //           this.form.itemList = res.data.data;
    //           this.ruleForm.form = res.data.data
    //           console.log('@' + this.form.itemList)
    //
    //         } else {
    //           // _this.$message.error(_this.$t("resultCodeInfo." + res.data.code));
    //         }
    //       })
    //       .catch((error) => {
    //         // _this.$message.error(_this.$t("resultCodeInfo.999"));
    //       });
    // },
    getBdzdb(cg, sqid) {
      let _this = this
      _this.$ajax
          .post("/api/rcsw/getBdzdb", _this.$qs.stringify({sqid: sqid}))
          .then((res) => {
            if (res.data.code == "200") {
              const formData = this.$refs.parser.formData
              if (cg == '1') {
                this.jsonData.disabled = false;
              } else {
                this.jsonData.disabled = true;
              }
              this.jsonData.fields.map((item, index) => {
                item.__config__.defaultValue = formData[item.__vModel__] = res.data.data[index].zd;
                return item;
              })
              this.$refs.parser.resetForm();
            } else {
              // _this.$message.error(_this.$t("resultCodeInfo." + res.data.code));
            }
          })
          .catch((error) => {
            // _this.$message.error(_this.$t("resultCodeInfo.999"));
          });
    },
    // 打开模态框会调用该方法
    queryUserInfo(sqid) {
      let _this = this
      _this.$ajax
          .post("/api/rcsw/xzsm", _this.$qs.stringify({sqid: sqid}))
          .then((res) => {
            if (res.data.code == "200") {
              this.result.cjrzjh = res.data.data.cjrzjh;
              this.result.cjsj = res.data.data.cjsj;
              this.result.lxmc = res.data.data.lxmc;
              this.result.fwjj = res.data.data.fwjj;
            } else {
              // _this.$message.error(_this.$t("resultCodeInfo." + res.data.code));
            }
          })
          .catch((error) => {
            // _this.$message.error(_this.$t("resultCodeInfo.999"));
          });
    },
    searchTdrInfo(sqid) {
      let _this = this
      _this.$ajax
          .post("/api/rcsw/getTdr", _this.$qs.stringify({sqid: sqid}))
          .then((res) => {
            if (res.data.code == "200") {
              this.result.xm = res.data.data.xm;
              this.result.xgh = res.data.data.xgh;
              this.result.bm = res.data.data.bm;
              this.result.lxfs = res.data.data.lxfs;
              this.result.dzyx = res.data.data.dzyx;

            } else {
              // _this.$message.error(_this.$t("resultCodeInfo." + res.data.code));
            }
          })
          .catch((error) => {
            // _this.$message.error(_this.$t("resultCodeInfo.999"));
          });
    },
    /** 删除申请单 */
    delInfo(sqid) {
      this.$confirm(
          this.$t('rcsw.sfscsqd') + sqid + '  ?',
          this.$t('rcsw.tips'),
          {
            distinguishCancelAndClose: true,
            confirmButtonText: this.$t('rcsw.confirmBtn'),
            cancelButtonText: this.$t('rcsw.cancelBtn'),
            type: 'warning'
          }
      )
          .then((res1) => {
            this.$ajax
                .post("/api/rcsw/delInfo", this.$qs.stringify({sqid: sqid}))
                .then((res) => {
                  if (res.data.code == "200") {
                    // this.searchUser("del");
                    this.$message.success(this.$t('common.delSuccess'));
                    this.searchUser('query');
                  } else {
                    this.$message.error(this.$t('common.delFail'));
                  }
                })
                .catch((error) => {
                  // this.$message.error('resultCodeInfo.999');
                });
          })
          .catch((action) => {
            // this.$message.info({
            //   message: action === 'cancel' ? '放弃保存并离开页面' : '停留在当前页面'
            // })
          });
    },
    // 下载附件信息
    filedownload(fj) {
      downLoadFile("/api/rcsw/filedownload", this.$qs.stringify({fj: fj.fj})).then(res => {
        debugger
        if (res.status === 200) {
          this.dialogFormVisible2 = false;
          this.$message.success(this.$t('rcsw.xzfjcg'));
          // 进行下载，下载文件时，显示文件名称
          openDialogDownload(res, fj.fjmc)//
        } else {
          console.log(res)
        }
      })
    },
    // 获取下载附件的信息
    getFjInfo(fwid) {
      let _this = this;
      this.fwfjList = [];
      _this.$ajax
          .post("/api/rcsw/getFwfjInfo", _this.$qs.stringify({fwid: fwid}))
          .then((res) => {
            if (res.data.code == "200") {
              this.fwfjList = res.data.data;
            } else {
              // _this.$message.error(_this.$t("resultCodeInfo." + res.data.code));
            }
          })
          .catch((error) => {
            // _this.$message.error(_this.$t("resultCodeInfo.999"));
          });
    },
    /** 查询列表信息 */
    searchUser(typeFlg) {
      let _this = this;

      this.tableData = [];
      this.tabLoading = false;
      if (typeFlg == "del" || typeFlg == "query") {
        _this.queryForm.currentPage = 1;
        _this.queryForm.limit = _this.$store.state.dataDisplayNum;
        _this.currentPage = 1;
      } else {
        _this.queryForm.currentPage = _this.currentPage;
        _this.queryForm.limit = _this.limit;
      }
      _this.$ajax
          .post("/api/rcsw/getByYhbh", _this.queryForm)
          .then((res) => {

            // 遍历前端后台返回的数据
            for (let i = 0; i < res.data.data.length; i++) {
              this.result.cg = res.data.data[i].cg;

            }
            if (res.data.code == "200") {
              if (res.data.data.length > 0) {
                _this.total = res.data.data[0].tableCount;
              }
              this.tableData = res.data.data;
            } else {
              // _this.$message.error(_this.$t("resultCodeInfo." + res.data.code));
            }
          })
          .catch((error) => {
            // _this.$message.error(_this.$t("resultCodeInfo.999"));
          });
    },
    /** 页码改变时会触发 */
    handleCurrentChange(uniqueNum, val) {
      this.currentPage = val;
      this.searchUser();
    },
    /** 每页条数改变时触发 */
    handleSizeChange(uniqueNum, val) {
      this.limit = val;
      this.currentPage = 1;
      this.searchUser();
    },
  },
  mounted() {
    this.searchUser("query");
    this.$requestUtil
        .getCodeInfoById(["NORMAL_CODE_USER_STATE"])
        .then((tmpResult) => {
          // 用户状态
          let userStateCodeList = tmpResult["NORMAL_CODE_USER_STATE"];
          for (let tmp of userStateCodeList) {
            this.optionsUserState.push({
              label: tmp.name,
              value: tmp.code,
            });
          }
        });
    // 监听浏览器的宽和高
    this.screenHeight = document.body.clientHeight;
    window.addEventListener(
        "resize",
        () => (this.screenHeight = window.innerHeight),
        false
    );
  },

}
</script>
<style lang="scss">
.rightClass {
  margin: 10px 0;
}

/*.el-input {
  width: 70%;
}*/

.el-button--danger {
  margin-left: 12px;
}

///* 表格不出现横向滚动条 */
//.el-table--scrollable-x .el-table__body-wrapper {
//  overflow-x: hidden;
//}

</style>
